/**
 * `snippets/age-gate.liquid` — `<age-gate>`: full-viewport age verification gate.
 *
 * "Yes" stores a one-week `age_verified` cookie and dismisses the gate; "No"
 * redirects the visitor away. The flash-prevention class on <html> is set by the
 * inline script in the snippet before paint, so this module only handles clicks.
 */

const COOKIE_NAME = 'age_verified'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 7 // one week, in seconds
const DECLINE_URL = 'https://google.com'

class AgeGate extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-age-gate-yes]')?.addEventListener('click', () => this.#accept())
    this.querySelector('[data-age-gate-no]')?.addEventListener('click', () => this.#decline())
  }

  #accept() {
    const secure = location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${COOKIE_NAME}=true; Max-Age=${COOKIE_MAX_AGE}; Path=/; SameSite=Lax${secure}`

    const root = document.documentElement
    root.classList.add('age-verified')
    root.classList.remove('age-gate-open')
    this.remove()
  }

  #decline() {
    globalThis.location.href = DECLINE_URL
  }
}

if (!customElements.get('age-gate')) {
  customElements.define('age-gate', AgeGate)
}
